import React from 'react';
import {Box, Nameplate as BaseNameplate} from '@tenancy.nz/design-system';

function Nameplate({...rest}) {
  const sx = {
    '.MuiBox-root > div:last-child': {
      flexBasis: {sm: '250px'},
    },
  };
  return (
    <Box sx={sx}>
      <BaseNameplate {...rest} />
    </Box>
  );
}

export default Nameplate;
